import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogTitle,
  Grid,
} from '@material-ui/core';
import React from 'react';

import { IWithStylesProps } from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import { LoadingView } from '~/src/dash/views/loading-view';

// this component is used to check if the user wants to include creatives when cloning an order
export interface IProps extends IWithStylesProps {
  active: boolean;
  onClose: () => void;
  loading: boolean;
  acknowledgement: string;
}

interface IState {
  updating: boolean;
}

export const ModalDialogCustomAcknowledgementView = decorate(
  {
    styles: (theme: any) => ({
      icon: {
        fontSize: '1rem',
        marginRight: '1rem',
      },
      error: {
        backgroundColor: theme.palette.error.dark,
      },
      message: {
        display: 'inline-flex',
        'align-items': 'center',
      },
    }),
  },
  class extends React.Component<IProps, IState> {
    state = {
      updating: false,
    };

    render() {
      const { updating } = this.state;
      const { acknowledgement, active, loading, onClose } = this.props;
      return !loading ? (
        <Grid>
          <Dialog
            open={active}
            onClose={onClose}
            disableBackdropClick={updating}
            disableEscapeKeyDown={updating}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <DialogTitle>{acknowledgement}</DialogTitle>
            <DialogActions>
              <Button
                onClick={() => {
                  onClose();
                }}
                disabled={updating}
              >
                Ok
                <span style={updating ? { opacity: 1 } : { opacity: 0 }}>
                  &nbsp;
                  <CircularProgress size={12} />
                </span>
              </Button>
            </DialogActions>
          </Dialog>
        </Grid>
      ) : (
        <LoadingView active={loading} text={'Loading...'} />
      );
    }
  },
);
